import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
const defaultProps = {
  label: 'Close'
};
const CloseButton = /*#__PURE__*/React.forwardRef(({
  label,
  onClick,
  className,
  ...props
}, ref) => /*#__PURE__*/_jsxs("button", {
  ref: ref,
  type: "button",
  className: classNames('close', className),
  onClick: onClick,
  ...props,
  children: [/*#__PURE__*/_jsx("span", {
    "aria-hidden": "true",
    children: "\xD7"
  }), /*#__PURE__*/_jsx("span", {
    className: "sr-only",
    children: label
  })]
}));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
export default CloseButton;